import React from "react";
import ThumbsUpSVG from "../../../assets/icons/helper-can-make.svg";

export const HelperCanMakeIcon: React.FC = () => {
  return <img src={ThumbsUpSVG} alt="" className="w-[22px] h-[22px] cursor-pointer" />;
};
